import useTranslations from "hooks/useTranslations"
import DisclosureList from "components/organisms/common/DisclosureList"
import Icon from "images/pro/team-problems.svg"
import cc from "classcat"

export default function ProblemsPro(props) {
  const {
    problemsProTitle,
    problemsPro1Title,
    problemsPro1Description,
    problemsPro2Title,
    problemsPro2Description,
    problemsPro3Title,
    problemsPro3Description,
    problemsPro4Title,
    problemsPro4Description,
    problemsPro5Title,
    problemsPro5Description,
  } = useTranslations()
  const list = [
    {
      name: problemsPro1Title,
      description: problemsPro1Description,
    },
    {
      name: problemsPro2Title,
      description: problemsPro2Description,
    },
    {
      name: problemsPro3Title,
      description: problemsPro3Description,
    },
    {
      name: problemsPro4Title,
      description: problemsPro4Description,
    },
    {
      name: problemsPro5Title,
      description: problemsPro5Description,
    },
  ]

  return (
    <DisclosureList
      title={problemsProTitle}
      list={list}
      Image={({ className }) => (
        <div
          className={cc([
            className,
            "grid h-full w-full place-items-center bg-zinc-800 p-6",
          ])}
        >
          <Icon className="w-1/2 text-kkm-green lg:w-64 lg:pr-10" />
        </div>
      )}
      {...props}
    />
  )
}
